import DetailedEvaluation from "../../Pages/DetailedEvaluation";


const navigation = {
  header: "Detailed Evaluation",
  links: [
    {
      text: "Detailed Evaluation",
      icon: <></>,
      route: "",
      component: DetailedEvaluation,
    },
  ],
};
export default navigation;
